// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let AnswerCollection
import { getAPIURL } from "assessments/utils"
const Answer = require("assessments/models/answer").default

export default AnswerCollection = (function () {
  AnswerCollection = class AnswerCollection extends (
    require("lib/static-shim").default(Backbone.Collection)
  ) {
    static initClass() {
      this.prototype.model = Answer
    }

    url() {
      const url = `${this.assessment.id}/answer`
      return getAPIURL(url, this, { user_id: this.user_id })
    }
  }
  AnswerCollection.initClass()
  return AnswerCollection
})()
